var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50002 19.0903C4.02728 19.25 4.73943 19.25 5.95 19.25H15.05C16.2606 19.25 16.9727 19.25 17.5 19.0903M3.50002 19.0903C3.38697 19.056 3.28242 19.0144 3.18327 18.9639C2.68935 18.7122 2.28778 18.3106 2.03611 17.8167C1.75 17.2552 1.75 16.5201 1.75 15.05V5.95C1.75 4.47986 1.75 3.74479 2.03611 3.18327C2.28778 2.68935 2.68935 2.28778 3.18327 2.03611C3.74479 1.75 4.47986 1.75 5.95 1.75H15.05C16.5201 1.75 17.2552 1.75 17.8167 2.03611C18.3106 2.28778 18.7122 2.68935 18.9639 3.18327C19.25 3.74479 19.25 4.47986 19.25 5.95V15.05C19.25 16.5201 19.25 17.2552 18.9639 17.8167C18.7122 18.3106 18.3106 18.7122 17.8167 18.9639C17.7176 19.0144 17.613 19.056 17.5 19.0903M3.50002 19.0903C3.50031 18.3821 3.50456 18.0074 3.56725 17.6922C3.84342 16.3038 4.92877 15.2184 6.31718 14.9423C6.65528 14.875 7.06185 14.875 7.875 14.875H13.125C13.9381 14.875 14.3447 14.875 14.6828 14.9423C16.0712 15.2184 17.1566 16.3038 17.4327 17.6922C17.4954 18.0074 17.4997 18.3821 17.5 19.0903M14 8.3125C14 10.2455 12.433 11.8125 10.5 11.8125C8.567 11.8125 7 10.2455 7 8.3125C7 6.3795 8.567 4.8125 10.5 4.8125C12.433 4.8125 14 6.3795 14 8.3125Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInactive);
export default __webpack_public_path__ + "static/media/user-inactive.8dc1d29391f5b4665ab801164ca98b73.svg";
export { ForwardRef as ReactComponent };